export default __webpack_public_path__ + "static/char-s-06-cht-06b7545ee132eef517a6aeb0528e1291.webp";